import React, { Component } from 'react';
import { connect } from 'react-redux';
import { List, ListItem, Card } from 'material-ui';
import {
  showNotification as showNotificationAction,
  translate as t,
  Restricted,
} from 'admin-on-rest';
import { getFormValues } from 'redux-form';

import Sheet from './sheet';
import References from '../References';

const restrictedWithData = (WrappedComponent) => {
  const hocComponent = ({ ...props }) => (
    <Restricted
      authParams={{ route: '/accounting-plans/:id' }}
      location={props.location}
    >
      <References
        {...props}
        references={[{ name: 'categories' }, { name: 'psps' }]}
      >
        <WrappedComponent {...props} />
      </References>
    </Restricted>
  );
  return hocComponent;
};

const Sheets = restrictedWithData((props) => (
  <List>
    <Card>
      <ListItem
        primaryText={props.translate(
          'resources.accountingPlans.fields.categories'
        )}
        primaryTogglesNestedList
        initiallyOpen
        nestedItems={[
          <Sheet
            {...props}
            property="categories"
            rows={props.choices.categories}
            data={props.record.categories}
            idKey="code"
            identifierKey="code"
          />,
        ]}
      />
    </Card>
    <Card>
      <ListItem
        primaryText={props.translate('resources.accountingPlans.fields.psps')}
        primaryTogglesNestedList
        initiallyOpen
        nestedItems={[
          <Sheet
            {...props}
            property="psps"
            rows={props.choices.psps}
            data={props.record.psps}
            idKey="id"
            identifierKey="name"
          />,
        ]}
      />
    </Card>
  </List>
));

class AccountingSheet extends Component {
  constructor(props) {
    super(props);
    this.state = { record: props.record };
  }
  updateRecord = (record) => this.setState({ record }, () => this.props.showNotification('Update success'));
  render() {
    return <Sheets {...this.props} record={this.state.record} afterUpdate={this.updateRecord} />;
  }
}

const selector = getFormValues('record-form');

export default connect(
  (state) => ({ record: selector(state) }),
  {
    showNotification: showNotificationAction,
  }
)(t(AccountingSheet));
